
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'
import CityCard from '../CityCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CityCard,
    InfiniteLoading
  }
})
export default class CityListGird extends Vue {
  @Prop({ default: 0 }) marginTop!: number

  get body() {
    return {
      statusArr: [EnumCityStatus.Assistance, EnumCityStatus.Inited].join(',')
    }
  }

  get pagePagination() {
    return this.$store.$tonghao.Guild.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  handleShowInit() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }
    this.$emit('show-init')
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
